/* eslint-disable angular/controller-name */

angular.
module("dx.webapp.navigation").
controller("dxNavigationActionController", function NavigationActionController(
	$window,

	DX_URLS
) {
	"use strict";

	var self = this;

	self.Urls = DX_URLS;

	self.blockSVGFocus = function blockSVGFocus() {
		var ngIncludes = $window.document.getElementsByTagName("ng-include");
		for (var i = 0; i < ngIncludes.length; i++) {
			ngIncludes[i].getElementsByTagName("svg")[0].setAttribute("focusable", "false");
		}
	};
});
